var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#8a8a8a",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.60301 14.4C2.60301 15.2824 3.32061 16 4.20301 16H12.203C13.0854 16 13.803 15.2824 13.803 14.4V4.8H15.403V3.2H12.203V1.6C12.203 0.7176 11.4854 0 10.603 0H5.80301C4.92061 0 4.20301 0.7176 4.20301 1.6V3.2H1.00301V4.8H2.60301V14.4ZM5.80301 1.6H10.603V3.2H5.80301V1.6ZM5.00301 4.8H12.203L12.2038 14.4H4.20301V4.8H5.00301Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.80301 6.40002H7.40301V12.8H5.80301V6.40002ZM9.00301 6.40002H10.603V12.8H9.00301V6.40002Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.514f02317847e20eb4fbaba5dda09b39.svg";
export { ForwardRef as ReactComponent };